import { useMemo } from 'react';

import { IconLabel } from '@components/icons/label';
import { IconStatusIndicator } from '@components/icons/status-indicator';
import { FilterConfigField } from '@components/table';

import { useStore } from 'models/Provider';

export const useMessageLabelsFilter = (): FilterConfigField => {
  const { t } = useStore();

  return useMemo(
    () => ({
      id: 'labels',
      label: t('messages.filters.label.title'),
      icon: <IconLabel />,
      type: 'multi_select',
      values: () => {
        return [
          {
            value: 'new',
            label: t('messages.filters.label.new'),
          },
        ];
      },
      quick: [
        {
          id: 'unread',
          label: t('messages.filters.quick.new.title'),
          apply: { comparer: 'is', value: 'new' },
          icon: <IconStatusIndicator color="green100" />,
        },
      ],
      allowedComparers: ['is', 'not_is'],
      toExternalQuery: (filter) => {
        switch (filter.comparer) {
          case 'is':
            return { [filter.value as string]: 'true' };
          case 'not_is':
            return { [filter.value as string]: 'false' };
          default:
            return {};
        }
      },
    }),
    [t]
  );
};
